import {
  type ClinicId,
  formatClinicAppointmentPenaltyFee,
  getClinicRegion,
} from '@snootsvet/shared'

import { ContactSupportAction } from '@/customer/components/contact-support-action'
import { Alert, AlertAction, AlertDescription, AlertTitle } from '@/customer/components/ui/alert'

export function AppointmentChangeWindowClosedAlert({ clinicId }: { clinicId: ClinicId | null }) {
  const region = clinicId ? getClinicRegion(clinicId) : undefined

  return (
    <Alert variant="warning">
      <AlertTitle>This appointment can't be changed</AlertTitle>
      <AlertDescription>
        <p>
          Appointments can't be cancelled or rescheduled within 24 hours of their start time.{' '}
          {clinicId ? (
            <span>
              A {formatClinicAppointmentPenaltyFee(clinicId)} no-show fee will apply if you don't
              attend.
            </span>
          ) : null}
        </p>
        <p>
          If exceptional circumstances mean you can't attend, contact the team as soon as possible.
        </p>
      </AlertDescription>
      <AlertAction>
        <ContactSupportAction region={region} urgent />
      </AlertAction>
    </Alert>
  )
}
